var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.8 32.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B0A31",
    d: "M39.8 3.8c-1.5.6-3 1.1-4.7 1.3 1.7-1 3-2.6 3.6-4.5-1.6.9-3.3 1.6-5.2 2C32.1 1 29.9 0 27.6 0c-4.5 0-8.2 3.7-8.2 8.2 0 .6.1 1.3.2 1.9-6.8-.4-12.8-3.7-16.8-8.6-.7 1.2-1.1 2.6-1.1 4.1 0 2.8 1.4 5.3 3.6 6.8-1.3 0-2.6-.4-3.7-1v.1c0 4 2.8 7.3 6.6 8-.7.2-1.4.3-2.2.3-.5 0-1-.1-1.5-.1 1 3.2 4.1 5.6 7.6 5.7-2.8 2.1-6.3 3.4-10.1 3.4-.7 0-1.3 0-2-.1 3.6 2.3 7.9 3.7 12.5 3.7 15 0 23.3-12.5 23.3-23.3V8c1.6-1.1 3-2.5 4-4.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.54bc52a948a2f164ba23d3274a6ea7da.svg";
export { ForwardRef as ReactComponent };